/* eslint-disable max-len */
import React, { useState, useRef,useContext } from 'react';
// import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import {motion} from 'framer-motion'
import CustomOverLay from '../../../../components/CustomOverLay';
import GlobalContext from '../../../../components/Context/GloablContext';
import SubdivisionDropdownWithSearch from '../../../ManageProvider/Components/SubdivisionDropdown';

export default function SubDivTable({id,
    result,
    subdivisionData,
    isOpensub,
    value,
    handleSubdivisionListSearch,
    handleAddAssociation,
    selectedSubdivisionName,
    setSelectedSubdivisionName,
    setisOpensub,
    handleSelectionSubdivision,
    subdivisionloadingstatus,
    limit,
    setLimit,
    totalPageNumber,
    fetchPageAndLimit,
    searchParams,
    setSearchParams,
    handleDeleteAssociatedOrganization,
    setLinkOrganizationModel,
    isSubDelete,
    setIsSubDelete
}) {
    const {isSideBar} = useContext(GlobalContext);
    const [isFirstTimeFeching,setIsFirstTimeFetching] = useState(true)
    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })

    const limitArr = [15, 30, 50, 100];
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    // useOnClickOutside(ref, () => {
    //     setIsOpen(false);
    // });

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit()
        setSearchParams(`${searchParams.split('?')[0]}?page_number=${pageNum}&limit=${params.get("limit")}&action=list`);
    };

    
    const handlePrevClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) - 1);
    };
    
    const handleNextClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) + 1);
    };


    function handleNoOfRowsClick(number) {
        const params = fetchPageAndLimit()
        setSearchParams(`${searchParams.split('?')[0]}?page_number=${params.get("page_number")}&limit=${number}&action=list`);
    }
   
    return (
        <>  
            <div className='bg-[#00000008] mt-4 rounded-lg pb-2 w-full'>
                <div className='relative flex justify-between items-center py-2 xl:pr-[51px] pr-[18px] pl-[18px] w-full'>
                    <h1 className='text-xl font-normal text-[#000000] '>Sub Division List</h1>
                    <div className='xl:w-[400px] w-[190px]'>
                        <SubdivisionDropdownWithSearch
                            label={"Sub Division Name"}
                            placeholder={'Select sub division name'}
                            id={'sub_division_name'}
                            subdivisionData={subdivisionData}
                            result={result}
                            value={value}
                            disabled={false}
                            handleSubdivisionListSearch={handleSubdivisionListSearch}
                            handleAddAssociation={handleAddAssociation}
                            selectedSubdivisionName={selectedSubdivisionName}
                            setSelectedSubdivisionName={setSelectedSubdivisionName}
                            setisOpensub={setisOpensub}
                            isOpensub={isOpensub}
                            handleSelectionSubdivision={handleSelectionSubdivision}
                            setSelectedOrganizationName={''}
                            subdivisionloadingstatus={subdivisionloadingstatus} 
                            isMonitor={true}
                            isFirstTimeFeching={isFirstTimeFeching}
                            setIsFirstTimeFetching={setIsFirstTimeFetching}
                            isSubDelete={isSubDelete} 
                            setIsSubDelete={setIsSubDelete}
                        /> 
                    </div>
                    {/* <button type='button' className="px-[15px] py-2.5 rounded-[15px] flex items-center hover:bg-[#E7EAF4] text-base font-normal text-[#000000]">
                        <img src="/images/add-plus-red.svg" alt="icon" />
                        <span className='pl-2'>
                            Add
                        </span>
                    </button> */}
                    <button type='button'
                        id={`add_subdivsion`}
                        className={`py-2.5 px-4 mt-[20px] flex items-center text-lg font-normal border border-[#972E4C] text-[#972E4C] rounded-[16px] ml-2.5 
                    bg-[#fff] disabled:opacity-50 min-w-max`}
                        onClick={() => {setLinkOrganizationModel(true),setisOpensub(false)}}
                        disabled={selectedSubdivisionName===''||selectedSubdivisionName === undefined||selectedSubdivisionName?.length===0 ? true : false}
                    >
                        <span className="mr-2.5"><img src="/images/add-plus-red.svg" alt="img" /></span>
                        Link Sub Division
                    </button> 
                </div>
                { ((result?.isFetching&&result?.status!=="fulfilled"&&result?.status!=="rejected")||(result?.isLoading)||(result?.data===undefined&&result?.status!=="fulfilled"&&result?.status!=="rejected"))?<CustomOverLay Active text="Loading subdivisions list..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>: <>
                    
                    <table aria-label="Outside Table" className="w-full table-auto">
                        <thead>
                            <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm  z-[1]">
                                <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        ID
                                    </span>
                                </th>
                                <th id="id" className="px-[18px] py-2 min-w-[100px]">
                                    <span className="flex items-center justify-start text-sm font-normal text-[#000000]">
                                        Sub Division Name
                                    </span>
                                </th>
                                <th id="id" className="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {result?.data?.data && result?.data?.data?.length>0 && result?.data?.data?.map((subdivision, index) => (
                        
                                <tr key={index}>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {subdivision.sub_division_id}
                        
                                    </td>
                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                        {subdivision.sub_division_name}
                                    </td>
                                    <td  className="px-[18px] py-2 text-sm text-center font-normal text-[#031624]" onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}}>
                                        {/* <button type="button">
                                            <img loading='lazy' decoding='async' src="/images/deleteicon-pink.svg" alt="delete-icon" />
                                        </button> */}
                                       
                                        {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation))?<>
                                            <motion.div
                                                initial={{ opacity: 1, x: 0,y:0 }}
                                                animate={{ opacity: 1, x: -40 ,y:0}}
                                                transition={{ delay: 0.2, duration: 0.5 }}
                                                exit={{ opacity: 0}}
                                                className=''
                                            >
                                                <button 
                                                    onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                                    onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}}
                                                    onClick={()=>{handleDeleteAssociatedOrganization(subdivision,index)}}  
                                                > 
                                                    <img src="/images/deleteicon-pink.svg" alt="img" /></button>
                                            </motion.div>
                                       
                                        </>:<button 
                                            onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}} 
                                            onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}}
                                            onClick={()=>{handleDeleteAssociatedOrganization(subdivision,index)}} 
                                            id={index + 'edit'} 
                                        > 
                                            <img src="/images/deleteicon-pink.svg" alt="img" /></button>}
                                       
                                        {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index && confirmation)) &&
                                            <motion.div
                                                initial={{ opacity: 0, x: 0,y:1 }}
                                                animate={{ opacity: 1, x: 0 ,y:1}}
                                                transition={{ delay: 0.4, duration: 0.5 }}
                                                exit={{ opacity: 0 }}
                                                className=''
                                            >
                                           
                                                <div className='relative ml-2 cursor-pointer mt-[-21px]' onClick={()=>{handleDeleteAssociatedOrganization(subdivision,index)}} >
                                           
                                                    <p className="  font-normal " style={{"font-size":"12px"}}>Remove</p>
                                       
                                                </div>
                                            </motion.div>
                                   
                                        }
                                        
                                    </td>
                                </tr>

                            ))}
                        
                        </tbody>
                    </table>

            
                    {result?.data && result?.data?.total_count>15 && 
                    <div className="w-[100%] px-2.5 pt-0 flex items-center justify-between bg-[#F4F7FC]">
                        <p className="text-sm font-semibold text-[#687182]">
                            Total Number of Records: {result?.data?.total_count}
                        </p>
                        <div className="flex items-center">
                            <div className={'relative pl-1'}>
                                <button
                                    ref={buttonRef}
                                    onClick={() => setIsOpen(!isOpen)}
                                    type="button"
                                    className="text-sm font-semibold text-[#687182] flex items-center"
                                >
                                    <p>Rows per page: {fetchPageAndLimit().get("limit")}</p>
                                    <span className="pl-0.5">
                                        <img
                                            src="/images/down.svg"
                                            className={`${isOpen ? "transform rotate-180" : ""}`}
                                            alt="icon"
                                            onClick={() => setIsOpen(!isOpen)}
                                        />
                                    </span>
                                </button>
                                <ul
                                    className={`absolute top-[-140px]  ml-[103px] pl-1.5 py-1.5 pr-0.5 z-[9999] bg-white border border-white h-fit rounded-sm shadow-xl ${isOpen ? "" : "hidden"}`}
                                    ref={dropdownRef}
                                >
                                    <li>
                                        <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin ">
                                            {limitArr.map((item, index) => (
                                                <li key={index}>
                                                    <h1
                                                        onClick={() => {
                                                            setLimit(item);
                                                            setIsOpen(false);
                                                            handleNoOfRowsClick(item);
                                                        }}
                                                        className={`text-base font-normal cursor-pointer ${
                                                            item === parseInt(limit) ? "text-[#008586]" : "text-[#00000]"
                                                        } mb-[16px]`}
                                                    >
                                                        {item}
                                                    </h1>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div className="flex items-center ml-5">
                                <button
                                    disabled={parseInt(fetchPageAndLimit().get("page_number")) === 1}
                                    onClick={handlePrevClick}
                                    className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                >
                                    <img src="/images/left.svg" alt="icon" />
                                </button>
                                <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                    <span className="text-[#171C26]">{fetchPageAndLimit().get("page_number")}</span>/{totalPageNumber}
                                </p>
                                <button
                                    disabled={parseInt(fetchPageAndLimit().get("page_number")) === totalPageNumber}
                                    onClick={handleNextClick}
                                    className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                                >
                                    <img src="/images/right.svg" alt="icon" />
                                </button>
                            </div>
                        </div>
                    </div>}
                </>}
               
            </div>
            
        </>
    )
}
